module.exports = __webpack_public_path__ + "static/media/brand16.33a2b31c.png";